import script from "./reissue-type-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./reissue-type-list.vue?vue&type=script&setup=true&lang=ts"

import "./reissue-type-list.vue?vue&type=style&index=0&id=61241c80&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61241c80"]])

export default __exports__